/**
 * @copyright (C) 2024, rsupport. All rights reserved
 *
 * @license
 * This software and/or source code may be used, copied and/or disseminated only
 * with the written permission of rsupport, or in accordance with the terms
 * and conditions stipulated in the agreement/contract under which the software
 * and/or source code has been supplied by rsupport or its affiliates.
 * Unauthorized use, copying, or dissemination of this file, via any medium, is
 * strictly prohibited, and will constitute an infringement of copyright.
 *
 * @author
 * Jinhyoung Jang (jangjh@rsupport.com)
 *
 * @description
 *
 * @created at 2024-12-10 11:44:23
 **/

import styled from "@emotion/styled";
import { Column, Row } from "@/frameworks/designStuff/components";
import { _T } from "@rfice/language";
import { Properties, useProperties } from "@rsupport/libraries";

import Layout from "../../Layout";
import GraphicContent from "./GraphicContent";

type GraphicOptions = {
	quality: Device.GraphicQuality;
};

export default function Graphic() {
	const graphic_options = useProperties(
		(state) => state.properties[state.selected].graphic_options as GraphicOptions
	);

	return (
		<Layout title={_T("그래픽 설정")}>
			<Contents>
				<Section>
					<Row gap={2}>
						<GraphicContent
							defaultValue={graphic_options.quality}
							onChange={(v) => {
								Properties.instance.set("graphic_options", {
									quality: v as Device.GraphicQuality
								});
							}}
						/>
					</Row>
				</Section>
			</Contents>
		</Layout>
	);
}

const Contents = styled(Column)`
	width: 100%;
	padding: 0 8px;
	margin-bottom: 12px;
`;

const Section = styled(Row)`
	padding: 8px 0;
	width: 100%;
	justify-content: space-between;
	align-items: center;
`;
